const API_BASE_URL = "/api";

export default API_BASE_URL;